var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form',{ref:"formedForm",attrs:{"rules":_vm.rules,"model":_vm.transferredForm,"label-position":"top","label-width":"120px"}},[_c('el-row',[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"date","label":"Дата"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date"},on:{"change":_vm.setDatastored},model:{value:(_vm.transferredForm.date),callback:function ($$v) {_vm.$set(_vm.transferredForm, "date", $$v)},expression:"transferredForm.date"}})],1)],1),_c('el-col',[(_vm.datastored !== null)?_c('el-form-item',{attrs:{"prop":"ammount","label":""}},[_vm._v(" Доступно на "+_vm._s(_vm.transferredForm.date)+" для проведения операции: "+_vm._s(_vm.datastored.amount - _vm.datastored.sumAmountGet)+" "+_vm._s(_vm.datastored.pss93UnitInfo.name)+" ")]):_vm._e()],1)],1),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_c('el-row',[_c('el-form-item',{attrs:{"prop":"store","label":"Количество"}},[_c('el-input',{model:{value:(_vm.transferredForm.store),callback:function ($$v) {_vm.$set(_vm.transferredForm, "store", $$v)},expression:"transferredForm.store"}}),_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.transferredForm.store),callback:function ($$v) {_vm.$set(_vm.transferredForm, "store", $$v)},expression:"transferredForm.store"}})],1)],1)],1),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Единица измерения"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.waste.pss93UnitInfo.name),callback:function ($$v) {_vm.$set(_vm.waste.pss93UnitInfo, "name", $$v)},expression:"waste.pss93UnitInfo.name"}})],1)],1)],1),_c('el-row',[(
          _vm.datastored !== null &&
          parseFloat(_vm.transferredForm.store.toString().replace(',', '.')) >
            _vm.valueDatastor
        )?_c('p',{staticStyle:{"color":"red"}},[_vm._v(" Ошибка! Превышение доступного количества отхода ")]):_vm._e()]),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"prop":"organizationInfoTransferredTo","label":"Филиал / Подразделение / Участок "}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","value-key":"id","filterable":"","placeholder":"Выберите"},model:{value:(_vm.transferredForm.organizationInfoTransferredTo),callback:function ($$v) {_vm.$set(_vm.transferredForm, "organizationInfoTransferredTo", $$v)},expression:"transferredForm.organizationInfoTransferredTo"}},_vm._l((_vm.filteredTransferOrganizationList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item}})}),1)],1)],1)],1),(_vm.transferredForm.organizationInfoTransferredTo.id !== null)?_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"prop":"","label":"Тех. процесс"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","value-key":"id","filterable":"","placeholder":"Выберите"},model:{value:(_vm.selectedTechProcess),callback:function ($$v) {_vm.selectedTechProcess=$$v},expression:"selectedTechProcess"}},_vm._l((_vm.transferredForm.organizationInfoTransferredTo
                .objectList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item}})}),1)],1)],1)],1):_vm._e(),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"prop":"pss18Info","label":"Цель:"}},[_c('el-select',{staticClass:"searchPole",attrs:{"clearable":"","value-key":"id","placeholder":"Причина передачи","filterable":""},model:{value:(_vm.transferredForm.pss18Info),callback:function ($$v) {_vm.$set(_vm.transferredForm, "pss18Info", $$v)},expression:"transferredForm.pss18Info"}},_vm._l((_vm.pss18TransferReasonInfoList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item}})}),1)],1)],1)],1)],1),_c('el-row',[_c('el-col',[_c('el-button',{staticStyle:{"float":"right"},attrs:{"type":"primary","disabled":parseFloat(_vm.transferredForm.store.toString().replace(',', '.')) >
            _vm.valueDatastor ||
          _vm.block ||
          (new Date(
            _vm.transferredForm.date.split('-')[0],
            _vm.transferredForm.date.split('-')[1] - 1,
            _vm.transferredForm.date.split('-')[2]
          ) < new Date(new Date().getFullYear(), 1, 1) &&
            (_vm.userId == 469 || _vm.userId == 470 || _vm.userId == 471)) ||
          (new Date(
            _vm.transferredForm.date.split('-')[0],
            _vm.transferredForm.date.split('-')[1] - 1,
            _vm.transferredForm.date.split('-')[2]
          ) <= new Date(2025, 2, 31) &&
            (_vm.userId == 253 ||
              _vm.userId == 254 ||
              _vm.userId == 255 ||
              _vm.userId == 256 ||
              _vm.userId == 257 ||
              _vm.userId == 258 ||
              _vm.userId == 259 ||
              _vm.userId == 260 ||
              _vm.userId == 261 ||
              _vm.userId == 262 ||
              _vm.userId == 336)) ||
          (new Date(
            _vm.transferredForm.date.split('-')[0],
            _vm.transferredForm.date.split('-')[1] - 1,
            _vm.transferredForm.date.split('-')[2]
          ) < new Date(new Date().getFullYear(), 2, 1) &&
            (_vm.userId == 482 || _vm.userId == 501)) ||
          (new Date(
            _vm.transferredForm.date.split('-')[0],
            _vm.transferredForm.date.split('-')[1] - 1,
            _vm.transferredForm.date.split('-')[2]
          ) < new Date(this.dateMinus1month.getFullYear(), 0, 1) &&
            _vm.userId != 266 &&
            _vm.userId != 267 &&
            _vm.userId != 268 &&
            _vm.userId != 269 &&
            _vm.userId != 270 &&
            _vm.userId != 271 &&
            _vm.userId != 272 &&
            _vm.userId != 273 &&
            _vm.userId != 274 &&
            _vm.userId != 275 &&
            _vm.userId != 276 &&
            _vm.userId != 277 &&
            _vm.userId != 278 &&
            _vm.userId != 279 &&
            _vm.userId != 280 &&
            _vm.userId != 281 &&
            _vm.userId != 282 &&
            _vm.userId != 283 &&
            _vm.userId != 284 &&
            _vm.userId != 285 &&
            _vm.userId != 286 &&
            _vm.userId != 287 &&
            _vm.userId != 288 &&
            _vm.userId != 289 &&
            _vm.userId != 290 &&
            _vm.userId != 233 &&
            _vm.userId != 234 &&
            _vm.userId != 25 &&
            _vm.userId != 464 &&
            _vm.userId != 371 &&
            _vm.userId != 344 &&
            _vm.userId != 292 &&
            _vm.userId != 245 &&
            _vm.userId != 14 &&
            _vm.userId != 465 &&
            _vm.userId != 505 &&
            _vm.userId != 506 &&
            _vm.userId != 507 &&  _vm.userId != 93 &&
            _vm.userId != 428 &&
            _vm.userId != 124 &&
            _vm.userId != 559 &&
            _vm.userId != 587 &&
            _vm.userId != 425 &&
            _vm.userId != 180 && _vm.userId != 344 && _vm.userId != 96)},on:{"click":_vm.save}},[_vm._v("Сохранить")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }